// extracted by mini-css-extract-plugin
export default {"container":"ProfilePage_container__oze8r","content":"ProfilePage_content__gl9Hm"};